import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
	ReturnOfInvestmentRequest,
	ReturnOfInvestmenResponse,
	RendimientoInversion,
} from 'src/app/models/apis/investment.model';
import {
	InvestmentProductsRequest,
	InvestmentProductsResponse,
	ProductoInversion,
} from 'src/app/models/apis/product-investment.model';
import {
	InvestmentSettings,
	ReturnOfInvestmentSimulator,
} from 'src/app/models/investment/investment.model';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class InvestmentService {
	private baseUrl: string = environment.cmvPlusServices;
	private httpHeaders: HttpHeaders;
	defaultInvestmentSettings: Array<InvestmentSettings>;
	constructor(private httpClient: HttpClient) {
		this.httpHeaders = new HttpHeaders()
			.set('X-IBM-Client-Id', environment.cmvplusClientID)
			.set('Usuario', 'CMVF1nZ4S')
			.set('Contrasena', '8DED40B6E19F14D1651FDDF063CDD2')
			.set('TokenAutorizacion', environment.cmvplusClientID);

		this.defaultInvestmentSettings = [
			{ rate: 9.23, period: 30 },
			{ rate: 11.5, period: 91 },
			{ rate: 12.22, period: 180 },
			{ rate: 13, period: 360 },
		];
	}

	getReturnOfInvestment(
		amount: number,
		type: string
	): Observable<Array<RendimientoInversion>> {
		const body: ReturnOfInvestmentRequest = {
			request: {
				FechaInicioInversion: new Date().toISOString(),
				IdModalidadInversion: 1,
				Monto: amount,
				Plazo: 0,
				TipoProductoInversion: type,
			},
		};
		return this.httpClient
			.post<ReturnOfInvestmenResponse>(
				`${this.baseUrl}inversiones/CalcularRendimientoInversion`,
				body,
				{
					headers: this.httpHeaders,
				}
			)
			.pipe(
				map(response => {
					const { Codigo, Estado, Modelo, Mensaje } =
						response.CalcularRendimientoInversionResult;
					if (Estado && Codigo === 200) {
						return Modelo.ModeloCalcularRendimientoInversion;
					}

					throw new Error(Mensaje);
				})
			);
	}

	getInvestmentProducts(type: string): Observable<Array<ProductoInversion>> {
		const body: InvestmentProductsRequest = {
			request: {
				TipoProductoInversion: type,
			},
		};
		return this.httpClient
			.post<InvestmentProductsResponse>(
				`${this.baseUrl}catalogo/ObtenerProductosInversion`,
				body,
				{
					headers: this.httpHeaders,
				}
			)
			.pipe(
				map(response => {
					return response.ObtenerProductosInversionResult.ProductosInversiones
						.ProductoInversion;
				})
			);
	}

	calculateAllReturnOfInvest(
		investmentSettings: Array<InvestmentSettings>,
		amount: number
	): Array<ReturnOfInvestmentSimulator> {
		const preReturnOfInvestmentResults: Array<ReturnOfInvestmentSimulator> =
			investmentSettings.map(setting => {
				const returnOfInvestment = this.calculateReturnOfInvest(
					setting.rate,
					setting.period,
					amount
				);
				return {
					...setting,
					returnOfInvestment,
					graphicHeight: 0,
				};
			});

		const maxReturnOfInvestment = preReturnOfInvestmentResults.reduce(
			(prev, current) =>
				prev.returnOfInvestment > current.returnOfInvestment ? prev : current
		).returnOfInvestment;

		return preReturnOfInvestmentResults.map(returnOfInvestmentResult => ({
			...returnOfInvestmentResult,
			graphicHeight:
				(returnOfInvestmentResult.returnOfInvestment * 110) /
				maxReturnOfInvestment,
		}));
	}

	calculateHeight(returnOfInvestment: number): number {
		const maxHeight = 110;
		const threshold = 100000;
		if (returnOfInvestment < threshold) {
			return (returnOfInvestment / threshold) * (maxHeight / 2) * maxHeight;
		} else {
			return (
				maxHeight / 2 +
				((returnOfInvestment - threshold) / threshold) *
					(maxHeight / 2) *
					maxHeight
			);
		}
	}

	calculateReturnOfInvest(
		rate: number,
		period: number,
		amount: number
	): number {
		const returnOfInvestment = (rate * period * amount) / 36000;
		return Number(returnOfInvestment.toFixed(2));
	}
}
